import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "..";
import {
  HATABOsTrackingAPIReqParams,
  HATABOTrackingResponse,
  HATLegAndQcDetailsReqParams,
  HATLegAndQcDetailsResponse,
  HATOverviewRequestParams,
  HATOverviewResponse,
  HATSummaryAPIReqParams,
  HATSummaryAPIResponse,
  HATUplineDiamondReqParams,
  HatUplineDiamondResponse,
} from "./HigherAwardTrackingAPI.types";

export const higherAwardTrackingAPI = createApi({
  reducerPath: "higherAwardTrackingAPI",
  baseQuery: dynamicBaseQuery,
  endpoints: (builder) => ({
    getHatOverview: builder.query<HATOverviewResponse, HATOverviewRequestParams>({
      query: (params) => {
        const { Abo, Aff, Period, IsoCountryCode, OverridePeriod } = params;
        const queryParams = new URLSearchParams({
          Abo,
          Aff,
          Period,
          IsoCountryCode,
          OverridePeriod: OverridePeriod.toString(),
        });

        return `/hat-faa/api/hatoverview?${queryParams}`;
      },
      // keep data for 1 hour
      keepUnusedDataFor: 3600,
    }),
    getHATSummary: builder.query<HATSummaryAPIResponse, HATSummaryAPIReqParams>({
      query: (params) => {
        const { Aff, Abo, Period, OverridePeriod } = params;
        const queryParams = new URLSearchParams({
          Aff,
          Abo,
          Period,
          OverridePeriod,
        });

        return `/hat-faa/api/hatsummary?${queryParams}`;
      },
      // keep data for 1 hour
      keepUnusedDataFor: 3600,
    }),
    getLegAndQcDetails: builder.query<HATLegAndQcDetailsResponse, HATLegAndQcDetailsReqParams>({
      query: (params) => {
        const { Abo, Aff, ClosingPeriod, PerfYear, Locale } = params;
        const queryParams = new URLSearchParams({
          Abo,
          Aff,
          ClosingPeriod,
          PerfYear,
          Locale,
        });

        return `/hat-faa/api/legqcdetails?${queryParams}`;
      },
      // keep data for 1 hour
      keepUnusedDataFor: 3600,
    }),
    getABOsTracking: builder.query<HATABOTrackingResponse, HATABOsTrackingAPIReqParams>({
      query: (params) => {
        const { Abo, Aff, ClosingPeriod, Locale } = params;
        const queryParams = new URLSearchParams({
          Abo,
          Aff,
          ClosingPeriod,
          Locale,
        });

        return `/hat-faa/api/legqcdetails/abos-tracking?${queryParams}`;
      },
      // keep data for 1 hour
      keepUnusedDataFor: 3600,
    }),
    getHatUplineDiamond: builder.query<HatUplineDiamondResponse, HATUplineDiamondReqParams>({
      query: (params) => {
        const { Abo, Aff, AffAbos, Period, Locale } = params;
        const queryParams = new URLSearchParams({
          Abo,
          Aff,
          AffAbos,
          Period,
          Locale,
        });

        return `/hat-faa/api/hat-upline-diamond?${queryParams}`;
      },
      // keep data for 1 hour
      keepUnusedDataFor: 3600,
    }),
  }),
});

export const {
  useGetHatOverviewQuery,
  useGetHATSummaryQuery,
  useGetLegAndQcDetailsQuery,
  useGetABOsTrackingQuery,
  useLazyGetHatUplineDiamondQuery,
} = higherAwardTrackingAPI;
